import { render } from "./BrandFilterItem.vue?vue&type=template&id=6f124a85"
import script from "./BrandFilterItem.vue?vue&type=script&lang=js"
export * from "./BrandFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__